module.exports = __webpack_public_path__ + "img/625.10eefa4e.png";